exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tests-public-page-container[data-v-4c184f5c] {\n  max-width: 700px;\n  width: 60%;\n  align-self: center;\n}\n@media (max-width: 768px) {\n.tests-public-page-container[data-v-4c184f5c] {\n    width: 100%;\n}\n}\n.tests-public-page-description[data-v-4c184f5c] {\n  font-size: 0.8rem;\n  margin-top: 1rem;\n  opacity: 0.85;\n}\n#tests-public-page[data-v-4c184f5c] {\n  padding: 30px;\n  width: 100%;\n  border-radius: 10px;\n  box-shadow: -2px 0px 8px -2px #a3a5ba;\n}", ""]);

// exports
